import * as React from "react";
import { ModalContext } from "../modal-provider/modal-provider.mjs";
const ModalCloser = (props) => {
  const { children } = props;
  const { close } = React.useContext(ModalContext);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) {
      return child;
    }
    return React.cloneElement(child, {
      onClick: (event) => {
        event.preventDefault();
        const closeResult = close(event, child.props.onClick);
        if (closeResult === null) {
          child.props.onClick(event);
        }
      }
    });
  }));
};
export {
  ModalCloser
};
